import { NodeDataKey } from '@ardoq/yfiles';
import {
  MODERNIZED_BLOCK_DIAGRAM_EXPANDER_SIZE as EXPANDER_SIZE,
  MODERNIZED_BLOCK_DIAGRAM_GROUP_PADDING as PADDING,
} from 'tabview/blockDiagram/view/yFilesExtensions/modernized/consts';

export const MAIN_LABEL = new NodeDataKey<string>('MAIN_LABEL');
export const SUB_LABEL = new NodeDataKey<string>('SUB_LABEL');
export const HAS_URL_FIELDS = new NodeDataKey<boolean>('HAS_URL_FIELDS');
export const HAS_REPRESENTATION_DATA = new NodeDataKey<boolean>(
  'HAS_REPRESENTATION_DATA'
);
export const OTHER_LABELS = new NodeDataKey<string>('OTHER_LABELS');

/**
 * the left group inset.
 *
 * this is enough space to leave a column on the left side of the group, as wide as the group expander click region.
 *
 * this prevents nodes from being placed along the left side of groups.
 *
 * in turn, this prevents edges from routing through this space and blocking the expander button.
 */
export const MODERNIZED_BLOCK_DIAGRAM_LEFT_INSET = EXPANDER_SIZE + 2 * PADDING;
